import React from "react";

import { zipObj, pluck } from "ramda";

import { format as d3Format } from "d3-format";

import { color as d3Color } from "d3-color";

import { withStyles } from "@material-ui/core/styles";

import LegendItem from "./LegendItem";

import { useTranslation } from "react-i18next";

import { CASES_KEY } from "lib/config";

import {
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";

const tooltipMobilityFormat = d3Format(",.2~f");
const tooltipCasesFormat = d3Format(",");

const TooltipPaper = withStyles((theme) => ({
  root: {
    backgroundColor: d3Color(theme.palette.primary.light)
      .copy({ opacity: 0.8 })
      .formatRgb(),
    padding: theme.spacing(1),
  },
}))(Paper);

const TooltipTableRowHeader = withStyles((theme) => ({}))(TableRow);

const TooltipTableCell = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0, 1, 1),
    ...theme.typography.body2,
    lineHeight: theme.typography.caption.lineHeight,
  },
}))(TableCell);

const TooltipTableHeaderCell = withStyles((theme) => ({
  root: {
    color: theme.palette.text.primary,
    fontWeight: "400",
  },
}))(TooltipTableCell);

const TooltipTableContainer = withStyles((theme) => ({
  root: {
    "& *": {
      borderBottom: 0,
    },
  },
}))(TableContainer);

export default function MobilityTimelineTooltip({
  dateFormatter,
  lines,
  baselineDate,
  payload,
  active,
  mobilityChangeFormatter
}) {
  const { t } = useTranslation();

  if (!active || !payload) {
    return null;
  }

  const payloadDict = zipObj(
    pluck("dataKey")(payload),
    pluck("value")(payload)
  );

  return (
    <Box p={1}>
      <TooltipPaper elevation={2}>
        <TooltipTableContainer size="small">
          <Table>
            <TableBody>
              <TooltipTableRowHeader>
                <TooltipTableHeaderCell align="right">
                  <Typography variant="h6">
                    {dateFormatter(payload[0].payload.date)}
                  </Typography>
                </TooltipTableHeaderCell>
                <TooltipTableHeaderCell align="right" style={{ maxWidth: 80 }}>
                  {t("mobilityTimeline.tooltip.mobilityChange", {
                    baselineDate: dateFormatter(baselineDate),
                  })}
                </TooltipTableHeaderCell>
                <TooltipTableHeaderCell align="right">
                  {t("mobilityTimeline.tooltip.totalCases")}
                </TooltipTableHeaderCell>
              </TooltipTableRowHeader>
              {lines.map(({ id, name, color }) => {
                return (
                  <TableRow key={id}>
                    <TooltipTableCell align="right" component="th" scope="row">
                      <LegendItem key={id} label={name} color={color} />
                    </TooltipTableCell>
                    <TooltipTableCell align="right">
                      {mobilityChangeFormatter(
                        payloadDict[`content.${id}.mobilityChange`]
                      )}
                    </TooltipTableCell>
                    <TooltipTableCell align="right">
                      {payloadDict[`content.${id}.${CASES_KEY}`]
                        ? tooltipCasesFormat(payloadDict[`content.${id}.${CASES_KEY}`])
                        : ""}
                    </TooltipTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TooltipTableContainer>
      </TooltipPaper>
    </Box>
  );
}
